import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0d274eee")

_pushScopeId("data-v-0d274eee")
const _hoisted_1 = { class: "m-list-item-root" }
const _hoisted_2 = { class: "item-header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "limit" }
const _hoisted_5 = { class: "item-footer" }
const _hoisted_6 = { class: "item-summary-wrap" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "circle red" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = { class: "circle blue" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "circle green" }, "和", -1)
const _hoisted_15 = { class: "value" }
const _hoisted_16 = {
  key: 0,
  class: "item"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "circle red" }, "庄对", -1)
const _hoisted_18 = { class: "value" }
const _hoisted_19 = {
  key: 1,
  class: "item"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "circle blue" }, "闲对", -1)
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "item-btn-wrap" }
const _hoisted_23 = { class: "btn" }
const _hoisted_24 = { class: "limit-pop-content" }
const _hoisted_25 = { class: "limit-pop-head" }
const _hoisted_26 = { class: "limit-pop-list" }
const _hoisted_27 = { class: "limit-pop-item-label" }
const _hoisted_28 = { class: "limit-pop-item-value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_road_map_view = _resolveComponent("road-map-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createVNode("div", {
        class: ["timer", _ctx.timerClass]
      }, _toDisplayString(_ctx.currentTime !== -1 ? _ctx.currentTime : ''), 3),
      _createVNode("div", _hoisted_4, "游戏ID:" + _toDisplayString(_ctx.gameId), 1)
    ]),
    _createVNode(_component_road_map_view, {
      class: "item-map",
      mapData: _ctx.deskResult,
      display: 2,
      onRoadMapData: _ctx.OnRoadMapData,
      predictionEnabled: true
    }, null, 8, ["mapData", "onRoadMapData"]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.deskData.gameType === 1 ? '庄' : '龙'), 1),
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.redCount), 1)
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.deskData.gameType === 1 ? '闲' : '虎'), 1),
          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.blueCount), 1)
        ]),
        _createVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode("span", _hoisted_15, _toDisplayString(_ctx.greenCount), 1)
        ]),
        (_ctx.deskData.gameType === 1)
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              _hoisted_17,
              _createVNode("span", _hoisted_18, _toDisplayString(_ctx.redPairCount), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.deskData.gameType === 1)
          ? (_openBlock(), _createBlock("div", _hoisted_19, [
              _hoisted_20,
              _createVNode("span", _hoisted_21, _toDisplayString(_ctx.bluePairCount), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("div", _hoisted_23, _toDisplayString(_ctx.iN('tables.startgame')), 1)
      ])
    ]),
    (_ctx.selectedIndex === _ctx.itemIndex)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "limit-pop",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, _toDisplayString(_ctx.iN('tables.selectlimit')), 1),
            _createVNode("div", _hoisted_26, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableLimits, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "limit-pop-list-item",
                  key: index,
                  onClick: ($event: any) => (_ctx.enterDesk(item))
                }, [
                  _createVNode("span", _hoisted_27, _toDisplayString(_ctx.iN('tables.limit')), 1),
                  _createVNode("span", _hoisted_28, _toDisplayString(item.Min) + " - " + _toDisplayString(item.Max), 1)
                ], 8, ["onClick"]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})